<template>
    <div class="StepCondition card">
        <div class="card-header">
            {{ $f.tc('triggeredBy') }}
        </div>
        <div class="card-body">
            <div v-for="(trigger, i) in triggerList" :key="i" class="trigger-item">
                <v-layout>
                    <v-select
                        outlined
                        dense
                        hide-details
                        :items="getIntentList(i)"
                        v-model="trigger.config"
                        :label="self.$f.tc('intent')"
                        @input="save(i)"
                    ></v-select>
                    <v-btn icon class="ml-1" @click="deleteTrigger(i)">
                        <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                </v-layout>
                <ul class="mt-1">
                    <li v-for="sample in mapIntentToSampleList[trigger.config]" :key="sample.code">
                        {{ sample.content }}
                    </li>
                </ul>
            </div>
            <div class="trigger-item">
                <div class="button-list mt-0">
                    <div
                        class="button-add button-item"
                        @click="addTrigger"
                        :disabled="disableAddTrigger"
                    >
                        <v-icon color="primary" small class="mr-1">mdi-plus-circle</v-icon>
                        {{ $f.tc('intent') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import lodash from 'lodash'
import { mapState } from 'vuex'
import { NlpService } from '@/services/bot.service'

export default {
    name: 'StepCondition',
    props: {
        step: Object
    },
    data () {
        return {
            self: this,
            triggerList: [],
            mapIntentToSampleList: {}
        }
    },
    computed: {
        ...mapState({
            intentList: state => state.scenario.intentList,
            shouldUpdateGraph: state => state.scenario.shouldUpdateGraph,
            mapIntentToStep: state => state.scenario.mapIntentToStep
        }),
        disableAddTrigger () {
            if (this.triggerList.length < 1) {
                return false
            }
            return !this.triggerList[this.triggerList.length - 1].config
        }
    },
    methods: {
        refresh () {
            this.triggerList = this.$ut.cloneObject(this.step.config).sort(
                (a, b) => a.created_time.localeCompare(b.created_time)
            )
            let promiseList = []
            this.triggerList.forEach(trigger => {
                promiseList.push(
                    NlpService.getIntentSample(this.$route.params.botCode, trigger.config).then(result => {
                        this.mapIntentToSampleList[trigger.config] = result.data
                    })
                )
            })
            Promise.allSettled(promiseList).finally(() => {
                this.$forceUpdate()
            })
        },
        addTrigger () {
            this.triggerList.push({
                name: 'TRIGGER',
                type: 'trigger',
                config: '',
                step_code: this.step.code
            })
        },
        async deleteTrigger (index) {
            let trigger = this.triggerList[index]
            if (trigger.config) {
                let confirm = await this.$appService.confirm(this.$f.tc('confirmDelete', { item: trigger.config }))
                if (!confirm) {
                    return
                }
            }
            if (trigger.code) {
                this.$store.dispatch(this.$at.scenario.DELETE_STEP_CONFIG, trigger)
            } else {
                this.triggerList.splice(index, 1)
            }
        },
        getIntentList (i) {
            return lodash.orderBy(this.intentList, 'label').map(intent => {
                return {
                    text: intent.label,
                    value: intent.label,
                    disabled: this.triggerList[i].config !== intent.label && !!this.mapIntentToStep[intent.label]
                }
            })
        },
        save (index) {
            let trigger = this.triggerList[index]
            NlpService.getIntentSample(this.$route.params.botCode, trigger.config).then(result => {
                this.mapIntentToSampleList[trigger.config] = result.data
                this.$forceUpdate()
            })
            if (trigger.code) {
                this.$store.dispatch(this.$at.scenario.UPDATE_STEP_CONFIG, trigger).then(newTrigger => {
                    this.triggerList.splice(index, 1, newTrigger)
                })
            } else {
                this.$store.dispatch(this.$at.scenario.CREATE_STEP_CONFIG, trigger).then(newTrigger => {
                    this.triggerList.splice(index, 1, newTrigger)
                })
            }
        }
    },
    watch: {
        step: {
            immediate: true,
            handler: function () {
                this.refresh()
            }
        },
        shouldUpdateGraph: 'refresh'
    }
}
</script>
